export default __webpack_public_path__ + "static/media/gt3.a3907160.png";